import { authedFetch } from '@features/auth/api/authRefresh'

/**
 * Trusted devices REST client (Track E-3、Settings レビュー リスク B Medium)。
 *
 * - `GET  /users/me/devices`        → 一覧
 * - `DELETE /users/me/devices/:id`  → 個別 revoke (204)
 *
 * いずれも JwtAuthGuard 保護のため `authedFetch` 経由 (401 retry あり)。
 */

export interface DeviceListItemWire {
  id: string
  userAgent: string | null
  ipPrefix: string | null
  createdAt: string
  lastUsedAt: string
  isCurrent: boolean
}

export interface ListDevicesResponseWire {
  devices: DeviceListItemWire[]
}

export const listDevices = (): Promise<ListDevicesResponseWire> =>
  authedFetch<ListDevicesResponseWire>('/users/me/devices', { method: 'GET' })

export const revokeDevice = (sessionId: string): Promise<void> =>
  authedFetch<void>(`/users/me/devices/${encodeURIComponent(sessionId)}`, { method: 'DELETE' })
